import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import { push } from "redux-router";
import constants from "constants";
import actions from "actions";
import _ from "lodash";
import { transformWebinarResponse } from "../utils/webinar-response-transformer";

const { addRequestError, addClientWebinars, addClientUrls } = actions;

const {
  LOAD_CLIENT_WEBINARS_SAGA,
  API_CLIENT_WEBINARS,
  API_CLIENT_URLS,
  LOAD_CLIENT_URLS_SAGA,
} = constants;

const apiLoadClientWebinars = async ({ scope, slug, page, params }) => {
  const response = await axios.get(
    `${API_CLIENT_WEBINARS}?scope=${scope}_webinars&slug=${slug}&page=${page}`,
    { params }
  );
  return transformWebinarResponse(response);
};

const apiLoadClientUrl = () => axios.get(API_CLIENT_URLS);

function* loadClientWebinars(params) {
  try {
    const response = yield call(apiLoadClientWebinars, params);
    const webinars = response.data.webinars;

    yield put(
      addClientWebinars(
        params.scope,
        webinars,
        response.data.count,
        response.data.pages
      )
    );
  } catch (e) {
    yield put(addRequestError(e.response));

    if (e.response.status === 404) {
      yield put(push("/"));
    }
  }
}

function* loadClientUrl() {
  try {
    const response = yield call(apiLoadClientUrl);
    const clientUrl = response.data.client_urls;

    yield put(addClientUrls(clientUrl));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* __loadClientWebinarsSaga() {
  yield takeEvery(LOAD_CLIENT_WEBINARS_SAGA, loadClientWebinars);
}

function* __loadClientUrlSaga() {
  yield takeEvery(LOAD_CLIENT_URLS_SAGA, loadClientUrl);
}

export { __loadClientWebinarsSaga, __loadClientUrlSaga };



// WEBPACK FOOTER //
// ./src/sagas/clientUrls.js